import { render, staticRenderFns } from "./activity_settings.vue?vue&type=template&id=40d4e60c&scoped=true&lang=html&"
import script from "./activity_settings.vue?vue&type=script&lang=js&"
export * from "./activity_settings.vue?vue&type=script&lang=js&"
import style0 from "./activity_settings.vue?vue&type=style&index=0&id=40d4e60c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d4e60c",
  null
  
)

export default component.exports